<template>
  
    <div>
      <div class="image-wrapper" @click="toggleZoom">          
        <img v-if="name != null" :src="`data:image/jpeg;base64,${imageSrc}`" :id="id"  :class="{ zoomed: isZoomed }" alt="" />          
      </div>      

      <b-button v-if="(chip == 0)" @click="triggerFileInput">أرفق صورة</b-button>
  
      <!-- Hidden file input -->
      <input type="file" ref="fileInput" :id="`fileInput${id}`" @change="testSelect" style="display: none;" />
  
      <!-- Display selected file name -->
      <!--<div v-if="file">
        <p>{{ file.name }}</p>
      </div>
      <div v-else-if="name != ''">
        <p>{{ name }}</p>
      </div>-->
  
      <!-- Upload file button 
      <button v-if="file" @click="uploadFile">Upload File</button>-->
    </div>
  </template>
  
  <script>
  import { ref } from 'vue'
  export default {
    props: {
    name: String,
    id: Number,
    imageSrc:String,
    chip: Number,
    date:String
  },    
    data() {
      return {
        isZoomed : ref(false),
        file: null,  // To hold the selected file
      };
    },
    methods: {
      toggleZoom() {
        this.isZoomed.value = !this.isZoomed.value
      },
      // Trigger the file input click action
      triggerFileInput() {
        this.$refs.fileInput.click();
      },
      testSelect(){
        const fileInput = document.getElementById('fileInput'+this.id)
        const previewImg = document.getElementById(this.id)
        const file = fileInput.files[0]
        const formData = new FormData();          
        formData.append('file', file);
        formData.append('id', this.id);

      if (file) {
        const reader = new FileReader()

        reader.onload = (e) => {
          previewImg.src = e.target.result
          previewImg.style.display = 'block'
        }

        reader.readAsDataURL(file)
        this.$http.post("/attachment", formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(/*response => {
            //console.log('File uploaded successfully:', response.data);
          }*/)
          .catch(error => {
            console.error('File upload failed:', error);
          });
      } else {
        previewImg.style.display = 'none'
        alert('Please select a valid image file.')
      }
      },
      // Handle the file when the user selects it
     handleFileUpload(event) {
        const selectedFile = event.target.files[0]; // Get the first selected file
        if (selectedFile) {
          this.file = selectedFile;  // Store the selected file in data
          if (this.file) {
          const formData = new FormData();
          formData.append('file', this.file);
          formData.append('id', this.id);
          
          const reader = new FileReader()
            reader.onload = (e) => {
               // Base64 string with data:image/jpeg;base64,...              
              this.imageSrc = e.target.result;
            }
            reader.readAsDataURL(event.target.files[0]) // Convert file to base64
            //this.imageSrc = reader.readAsDataURL(selectedFile)
            
          
          // Example: upload the file using Axios
          //this.$axios.post('your-upload-endpoint', formData)
          this.$http.post("/attachment", formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(/*response => {
            //console.log('File uploaded successfully:', response.data);
          }*/)
          .catch(error => {
            console.error('File upload failed:', error);
          });
        }
        }
      },
  
      // Example method to upload the file to a server
      uploadFile() {
        
      },
    },
  };
  </script>
  
  <style scoped>
  .image-wrapper img {
    width: 100%;           /* Make it responsive */
    max-width: 300px;      /* Or any fixed size */
    height: auto;
    max-height: 300px;          /* Maintain aspect ratio */
    object-fit: cover;     /* Crop if necessary, or use "contain" to fit */
    border-radius: 10px;
    transition: transform 0.3s ease;
  }
  
  /* Optional: Add hover zoom effect */
  .image-wrapper img:hover {
    /*transform: scale(1.05); /* Slight zoom on hover */
    transform: scale(1.5);
  }
  .image-wrapper img{
  
}
  button {
    margin-top: 10px;
  }
  
  </style>